export const MAX_PAGINATION_ITEMS = 10;

export const findNumeroElementi = (pageNumber) => (pageNumber - 1) * MAX_PAGINATION_ITEMS;
